import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "tciTruncate" })
export class NgTCITruncatePipe implements PipeTransform {

  transform(str: string, limit: number, isShowEllipsis: boolean = true): string {
    if (str.length > limit) {
      str = str.substring(0, limit) + (isShowEllipsis ? "..." : "");
    }
    return str;
  }
}
